"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.URLInput = exports.PasswordInput = exports.PhoneInput = exports.NumberInput = exports.EmailInput = void 0;
exports.TextInput = TextInput;
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var BlockLabel_1 = require("../BlockLabel");
var LoadersAndProgress_1 = require("../../../components/LoadersAndProgress");
var OKELink_1 = require("../OKELink");
var _EXPORTS_1 = require("../../../utils/_EXPORTS");
var utilsOolib_1 = require("../../../utilsOolib");
var themes_1 = require("../../themes");
var Typo2_1 = require("../Typo2");
var index_styled_1 = require("./index.styled");
var DisplayIcon_1 = require("../../../utils/comps/DisplayIcon");
var EmailInput_1 = require("./derivedComps/EmailInput");
Object.defineProperty(exports, "EmailInput", { enumerable: true, get: function () { return EmailInput_1.EmailInput; } });
var PasswordInput_1 = require("./derivedComps/PasswordInput");
Object.defineProperty(exports, "PasswordInput", { enumerable: true, get: function () { return PasswordInput_1.PasswordInput; } });
var URLInput_1 = require("./derivedComps/URLInput");
Object.defineProperty(exports, "URLInput", { enumerable: true, get: function () { return URLInput_1.URLInput; } });
var NumberInput_1 = require("./derivedComps/NumberInput");
Object.defineProperty(exports, "NumberInput", { enumerable: true, get: function () { return NumberInput_1.NumberInput; } });
var PhoneInput_1 = require("./derivedComps/PhoneInput");
Object.defineProperty(exports, "PhoneInput", { enumerable: true, get: function () { return PhoneInput_1.PhoneInput; } });
var icons_1 = require("../../../icons");
var Buttons_1 = require("../Buttons");
var mixins_1 = require("../../../themes/mixins");
var BadgeVetted = icons_1.icons.BadgeVetted;
function TextInput(_a) {
    var _this = this;
    var S = _a.S, id = _a.id, disabled = _a.disabled, icon = _a.icon, type = _a.type, _b = _a.placeholder, placeholder = _b === void 0 ? "Enter Text..." : _b, _c = _a.value, value = _c === void 0 ? "" : _c, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, readOnly = _a.readOnly, iconOnClick = _a.iconOnClick, iconAfter = _a.iconAfter, handleValidation = _a.handleValidation, _d = _a.validateOnMount, validateOnMount = _d === void 0 ? true : _d, // i think it makes sense to always run validation the minute the comp mounts, but we will see if this has sideeffects
    actionBtn = _a.actionBtn, clearBtn = _a.clearBtn, className = _a.className, maxLength = _a.maxLength, DEPRECATED_maxNumLimiter = _a.maxNumLimiter, forceFocus = _a.forceFocus, //sometimes, when some other elem is clicked, we wanna trigger focus on the textinput. eg. when on mobile, the search icon is clicked on the listingpage
    _e = _a.validateOnlyOnBlur, //sometimes, when some other elem is clicked, we wanna trigger focus on the textinput. eg. when on mobile, the search icon is clicked on the listingpage
    validateOnlyOnBlur = _e === void 0 ? false : _e, //for example, in the login form we want validation to only run, once the text input is blurred. else it can be irritating
    _validationStatus = _a.validationStatus, _f = _a.displayValidationMsg, displayValidationMsg = _f === void 0 ? true : _f, content = _a.content, passValidationErrorToFormValidation = _a.passValidationErrorToFormValidation, plugin = _a.plugin;
    var props = arguments[0];
    var theme = (0, styled_components_1.useTheme)();
    var _g = (0, react_1.useState)(_validationStatus), validationStatus = _g[0], setValidationStatus = _g[1];
    (0, react_1.useEffect)(function () {
        setValidationStatus(_validationStatus);
    }, [_validationStatus]);
    var screenWidth = (0, _EXPORTS_1.useScreenWidth)();
    var actionBtnEnabaled = !!value && (type !== "url" ? true : (validationStatus === null || validationStatus === void 0 ? void 0 : validationStatus.type) === "success");
    var clearBtnEnabled = !!value && (type !== "url" ? true : (validationStatus === null || validationStatus === void 0 ? void 0 : validationStatus.type) === "success");
    var size = S
        ? (screenWidth >= (0, mixins_1.getBreakPoint)('md') ? "S" : "M") //wat this basically means is, a defined 'small' text input will dynamically become 'medium' when on mobile, which is in sync with the pattern of the rest of our components
        : "M";
    var handleValidate = function (e, onBlur) { return __awaiter(_this, void 0, void 0, function () {
        var value, res, validationPlugin, pluginResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    onBlur && onBlur(e);
                    value = e.target.value;
                    if (!value)
                        return [2 /*return*/];
                    if (type === "url")
                        setValidationStatus("loading");
                    if (!handleValidation) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleValidation(value)];
                case 1:
                    res = _a.sent();
                    setValidationStatus(res);
                    _a.label = 2;
                case 2:
                    validationPlugin = (plugin === null || plugin === void 0 ? void 0 : plugin.validation) &&
                        theme.pluginConfigs &&
                        theme.pluginConfigs.tplBlockPlugins[plugin.validation];
                    if (!validationPlugin) return [3 /*break*/, 4];
                    setValidationStatus("loading");
                    return [4 /*yield*/, validationPlugin({
                            value: value,
                            content: content,
                            passValidationErrorToFormValidation: passValidationErrorToFormValidation,
                        })];
                case 3:
                    pluginResponse = _a.sent();
                    //if plugin responds with undefined, it means it found no error. hence lets pass the 'success info' to passValidationErrorToFormValidation
                    if (!pluginResponse)
                        passValidationErrorToFormValidation("success");
                    setValidationStatus(pluginResponse);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (validateOnMount) {
            handleValidate({ target: { value: value } });
        }
    }, [validateOnMount]);
    var handleOnChange = function (e) {
        onChange(id, e.target.value);
        if (!e.target.value)
            setValidationStatus("");
        if (!validateOnlyOnBlur) {
            handleValidate(e);
        }
        else {
            /**
             * basically if an error has already been set then, run validation in realtime on change
             */
            if (validationStatus) {
                if (type === "url")
                    return setValidationStatus("");
                handleValidate(e);
            }
        }
    };
    var inputRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        forceFocus && inputRef.current && inputRef.current.focus();
    }, [forceFocus]);
    var localize = (0, utilsOolib_1.useLocale)();
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(BlockLabel_1.BlockLabel, __assign({}, (0, _EXPORTS_1.getBlockLabelProps)(props))),
        readOnly ? (type === "url"
            ? react_1.default.createElement(OKELink_1.OKELink, { text: value, to: value })
            : react_1.default.createElement(Typo2_1.UI_BODY_SM, null, type === "password" ? "********" : value)) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(index_styled_1.InputContainerStyled, { type: type, disabled: disabled, iconAfter: iconAfter, onClick: function () { return inputRef.current.focus(); }, size: size },
                icon && (react_1.default.createElement(DisplayIcon_1.DisplayIcon, { icon: icon, color: disabled ? themes_1.colors.grey40 : themes_1.colors.grey80, size: screenWidth >= (0, mixins_1.getBreakPoint)('md') ? 16 : 18, onClick: !disabled ? iconOnClick || null : undefined, style: { zIndex: 1 } /** so that it stays ahead of the before element inside InputContainerStyled */ })),
                react_1.default.createElement(index_styled_1.InputStyled, { ref: inputRef, className: "UI_BODY_SM_DF", id: id, type: type, name: type, disabled: disabled, placeholder: localize(placeholder), value: value, onChange: handleOnChange, maxLength: maxLength || DEPRECATED_maxNumLimiter, onBlur: validateOnlyOnBlur ? function (e) { return handleValidate(e, onBlur); } : onBlur, size: size, onFocus: onFocus, autoComplete: "off" }),
                validationStatus === "loading" && (react_1.default.createElement("div", { style: { zIndex: 1 } /** so that it stays ahead of the before element inside InputContainerStyled */ },
                    react_1.default.createElement(LoadersAndProgress_1.LoaderCircle, { S: true }))),
                (validationStatus === null || validationStatus === void 0 ? void 0 : validationStatus.type) === "success" && (react_1.default.createElement("div", { style: { zIndex: 1 } /** so that it stays ahead of the before element inside InputContainerStyled */ },
                    react_1.default.createElement(BadgeVetted, { size: 26 }))),
                (clearBtn && clearBtnEnabled) && (react_1.default.createElement(Buttons_1.ButtonSecondaryCompact, { onClick: function () { return onChange(id, ""); }, value: (clearBtn === null || clearBtn === void 0 ? void 0 : clearBtn.text) || "Clear", disabled: !clearBtnEnabled, style: { marginRight: size === "S" ? '-0.4rem' : '-0.2rem', zIndex: 1 } /** so that it stays ahead of the before element inside InputContainerStyled */ })),
                actionBtn && (react_1.default.createElement(Buttons_1.ButtonPrimaryCompact, { value: (actionBtn === null || actionBtn === void 0 ? void 0 : actionBtn.text) || "Action", onClick: actionBtnEnabaled && actionBtn.onClick, disabled: !actionBtnEnabaled, style: { marginRight: size === "S" ? '-0.4rem' : '-0.2rem', zIndex: 1 } /** so that it stays ahead of the before element inside InputContainerStyled */ }))),
            displayValidationMsg && (validationStatus === null || validationStatus === void 0 ? void 0 : validationStatus.msg) && (react_1.default.createElement(index_styled_1.MsgContainerStyled, { status: validationStatus === null || validationStatus === void 0 ? void 0 : validationStatus.type },
                (validationStatus === null || validationStatus === void 0 ? void 0 : validationStatus.type) === "error" && (react_1.default.createElement(DisplayIcon_1.DisplayIcon, { size: 12, icon: "WarningDiamond", weight: "fill", color: themes_1.colors.error })),
                react_1.default.createElement(Typo2_1.UI_HELPTEXT, null,
                    react_1.default.createElement("div", { style: { display: 'flex' } },
                        !((validationStatus === null || validationStatus === void 0 ? void 0 : validationStatus.type) === "success") && validationStatus.msg,
                        validationStatus.link && (react_1.default.createElement(OKELink_1.OKELink, { to: validationStatus.link.to, style: { marginLeft: "0.5rem" } }, validationStatus.link.text))))))))));
}
var Inputs = {
    EmailInput: EmailInput_1.EmailInput,
    NumberInput: NumberInput_1.NumberInput,
    PhoneInput: PhoneInput_1.PhoneInput,
    PasswordInput: PasswordInput_1.PasswordInput,
    URLInput: URLInput_1.URLInput,
};
